import { State as AppState } from '@/features/orders/constants/app'
import { State as FirebaseState } from '@/features/orders/constants/firebase'

export const firebaseToAppState: Record<FirebaseState, AppState> = {
    [FirebaseState.AwaitingAcceptance]: AppState.AwaitingAcceptance,
    [FirebaseState.Accepted]: AppState.Accepted,
    [FirebaseState.Production]: AppState.Production,
    [FirebaseState.Ready]: AppState.Ready,
    [FirebaseState.Delivering]: AppState.Delivering,
    [FirebaseState.Delivered]: AppState.Delivered,
    [FirebaseState.Cancelled]: AppState.Cancelled,
}
